import PropTypes from "prop-types";

const Services_Frame = ({ className = "" }) => {
  return (
    <div
      className={`bg-skyblue px-8 py-12 flex flex-col items-start justify-start box-border gap-[45px] text-left text-11xl text-deepskyblue-200 font-istok-web ${className}`}
    >
      <div className="flex flex-col items-center justify-start gap-[45px]">
        <b className="relative leading-[100%] uppercase">Services</b>
        <div className="relative leading-[130%] text-gray-200 text-center inline-block [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">{`At StaffSurge, we offer a wide range of recruitment services tailored to meet the specific needs of your business. Our solutions are designed to streamline your hiring process, reduce TAT and bring you the right talent quickly. We Specialize in: `}</div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 w-full text-center text-gray-100 gap-4">
        <div className="">
          <img className="h-[240px] object-cover" alt="" src="/pic-1@2x.png" />
          <b className="relative leading-[100%] uppercase inline-block shrink-0 mt-4">
            Permanent Staffing Solutions
          </b>
        </div>
        <div className="">
          <img className="h-[240px] object-cover" alt="" src="/pic-2@2x.png" />
          <b className="relative leading-[100%] uppercase inline-block shrink-0 mt-4">
            Temporary and Contract Staffing
          </b>
        </div>
        <div className="">
          <img className="h-[240px] object-cover" alt="" src="/pic-3@2x.png" />
          <b className="relative leading-[100%] uppercase inline-block shrink-0 mt-4">{`Executive Search & Headhunting`}</b>
        </div>
        <div className="">
          <img className="h-[240px] object-cover" alt="" src="/pic-4@2x.png" />
          <b className="relative leading-[100%] uppercase inline-block shrink-0 mt-4">
            third party payroll
          </b>
        </div>
      </div>
    </div>
  );
};

Services_Frame.propTypes = {
  className: PropTypes.string,
};

export default Services_Frame;
